var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniTransport01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.574219,
    y: 0.453125,
    width: 258,
    height: 252,
    fill: "#C87A7A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_485_19387",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.574219,
    y: 0.453125,
    width: 258,
    height: 252,
    fill: "#3D529B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_485_19387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.343 182.199C112.343 178.886 115.029 176.199 118.343 176.199H141.046C144.359 176.199 147.046 178.886 147.046 182.199V210.405C147.046 213.718 144.359 216.405 141.046 216.405H118.343C115.029 216.405 112.343 213.718 112.343 210.405V182.199Z",
    fill: "#200909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.528 51.6044C188.716 50.6711 189.536 50 190.488 50H224.595C225.547 50 226.367 50.6711 226.555 51.6044L229.666 67.0188H185.417L188.528 51.6044Z",
    fill: "#FFC7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.901 70.6944C132.429 67.8523 134.909 65.791 137.8 65.791H276.34C279.231 65.791 281.711 67.8523 282.239 70.6944L294.974 139.195H119.166L131.901 70.6944Z",
    fill: "#347E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.973 139.195L282.238 70.6944C281.71 67.8523 279.23 65.791 276.339 65.791H141.013L187.066 139.195H294.973Z",
    fill: "#245F6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.693 62.9267V53.9551H197.064C199.121 53.9551 200.218 55.2066 200.224 56.9291C200.218 58.6454 199.109 59.8907 197.039 59.8907H195.304V62.9267H193.693ZM195.304 58.5648H196.816C198.03 58.5586 198.576 57.8771 198.576 56.9291C198.576 55.9687 198.03 55.3058 196.816 55.3058H195.304V58.5648Z",
    fill: "#CF7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.008 63.0258C201.475 63.0258 201.035 62.5921 201.042 62.0593C201.035 61.5388 201.475 61.1113 202.008 61.1051C202.522 61.1113 202.962 61.5388 202.962 62.0593C202.962 62.5921 202.522 63.0258 202.008 63.0258Z",
    fill: "#CF7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.561 62.9267V53.9551H207.931C209.989 53.9551 211.085 55.2066 211.091 56.9291C211.085 58.6454 209.976 59.8907 207.907 59.8907H206.172V62.9267H204.561ZM206.172 58.5648H207.684C208.898 58.5586 209.443 57.8771 209.443 56.9291C209.443 55.9687 208.898 55.3058 207.684 55.3058H206.172V58.5648Z",
    fill: "#CF7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.904 53.9551V62.9267H212.318V53.9551H213.904Z",
    fill: "#CF7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.403 63.063C216.376 63.063 215.131 61.7123 215.131 59.6057C215.131 57.5239 216.395 56.1112 218.316 56.1112C219.964 56.1112 221.389 57.146 221.389 59.5066V60.0023H216.692C216.717 61.1485 217.393 61.83 218.415 61.8238C219.109 61.83 219.574 61.5326 219.778 61.1299H221.327C221.042 62.2947 219.964 63.063 218.403 63.063ZM216.699 58.9242H219.877C219.871 58.0072 219.251 57.338 218.341 57.338C217.393 57.338 216.754 58.0691 216.699 58.9242Z",
    fill: "#CF7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.057 76.3764C138.407 74.4789 140.061 73.1016 141.991 73.1016H272.15C274.08 73.1016 275.734 74.4789 276.084 76.3764L287.664 139.195H126.477L138.057 76.3764Z",
    fill: "#86B7C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.665 139.195L276.084 76.3764C275.734 74.4789 274.08 73.1016 272.15 73.1016H145.571L188.432 139.195H287.665Z",
    fill: "#6C99A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.166 139.195H294.974L309.594 154.118H104.546L119.166 139.195Z",
    fill: "#5CB0C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.546 154.119H309.594V188.282C309.594 193.805 305.117 198.282 299.594 198.282H114.546C109.023 198.282 104.546 193.805 104.546 188.282V154.119Z",
    fill: "#347E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.594 188.282V154.119H141.925L198.662 198.282H299.594C305.117 198.282 309.594 193.805 309.594 188.282Z",
    fill: "#245F6B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.692,
    y: 169.982,
    width: 67.6998,
    height: 20.1342,
    fill: "#FFC7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.392 169.982H173.692V178.931L188.283 190.117H241.392V169.982Z",
    fill: "#9B5050"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.937,
    y: 173.135,
    width: 61.2121,
    height: 13.8292,
    fill: "#C76E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.149 173.135H176.937V181.397L184.416 186.964H238.149V173.135Z",
    fill: "#933838"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_485_19387)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 129.695,
    cy: 180.146,
    r: 9.97001,
    fill: "#FFC7C7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.693 184.468V175.496H197.064C199.121 175.496 200.218 176.748 200.224 178.47C200.218 180.186 199.109 181.432 197.039 181.432H195.304V184.468H193.693ZM195.304 180.106H196.816C198.03 180.1 198.576 179.418 198.576 178.47C198.576 177.51 198.03 176.847 196.816 176.847H195.304V180.106Z",
    fill: "#842323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.008 184.567C201.475 184.567 201.035 184.133 201.042 183.6C201.035 183.08 201.475 182.652 202.008 182.646C202.522 182.652 202.962 183.08 202.962 183.6C202.962 184.133 202.522 184.567 202.008 184.567Z",
    fill: "#842323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.561 184.468V175.496H207.931C209.989 175.496 211.085 176.748 211.091 178.47C211.085 180.186 209.976 181.432 207.907 181.432H206.172V184.468H204.561ZM206.172 180.106H207.684C208.898 180.1 209.443 179.418 209.443 178.47C209.443 177.51 208.898 176.847 207.684 176.847H206.172V180.106Z",
    fill: "#842323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.904 175.496V184.468H212.318V175.496H213.904Z",
    fill: "#842323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.403 184.604C216.376 184.604 215.131 183.253 215.131 181.147C215.131 179.065 216.395 177.652 218.316 177.652C219.964 177.652 221.389 178.687 221.389 181.048V181.543H216.692C216.717 182.69 217.393 183.371 218.415 183.365C219.109 183.371 219.574 183.074 219.778 182.671H221.327C221.042 183.836 219.964 184.604 218.403 184.604ZM216.699 180.465H219.877C219.871 179.548 219.251 178.879 218.341 178.879C217.393 178.879 216.754 179.61 216.699 180.465Z",
    fill: "#842323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.347 110.132C123.285 109.631 122.86 109.254 122.355 109.254H119.167L121.625 126.925L124.701 121.136L123.347 110.132Z",
    fill: "#347E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.935 109.254H114.025C111.305 109.254 109.1 111.459 109.1 114.178V114.178C109.1 116.898 111.305 119.103 114.025 119.103H121.935V109.254Z",
    fill: "#347E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.935 110.942C121.935 110.818 121.834 110.717 121.709 110.717H114.025C112.113 110.717 110.563 112.267 110.563 114.179V114.179C110.563 116.091 112.113 117.641 114.025 117.641H121.709C121.834 117.641 121.935 117.541 121.935 117.416V110.942Z",
    fill: "#86B7C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.242 242.453V222.656H190.008C194.506 222.656 197.09 225.432 197.09 229.328C197.09 233.279 194.465 236 189.898 236H186.344V242.453H182.242ZM186.344 232.691H189.242C191.676 232.691 192.865 231.324 192.852 229.328C192.865 227.359 191.676 226.033 189.242 226.02H186.344V232.691ZM201.055 242.699C199.77 242.699 198.73 241.674 198.758 240.402C198.73 239.145 199.77 238.119 201.055 238.133C202.271 238.119 203.324 239.145 203.324 240.402C203.324 241.674 202.271 242.699 201.055 242.699ZM206.66 242.453V222.656H214.426C218.924 222.656 221.508 225.432 221.508 229.328C221.508 233.279 218.883 236 214.316 236H210.762V242.453H206.66ZM210.762 232.691H213.66C216.094 232.691 217.283 231.324 217.27 229.328C217.283 227.359 216.094 226.033 213.66 226.02H210.762V232.691ZM228.07 222.656V242.453H224.023V222.656H228.07ZM237.941 242.754C233.389 242.74 230.6 239.801 230.613 235.098C230.6 230.518 233.43 227.414 237.777 227.414C241.674 227.414 244.75 229.875 244.75 234.934V236.082H234.605C234.605 238.324 235.932 239.705 238.023 239.719C239.404 239.705 240.389 239.104 240.785 238.215H244.641C244.066 240.963 241.605 242.74 237.941 242.754ZM234.605 233.539H240.922C240.908 231.734 239.664 230.436 237.859 230.449C236 230.436 234.688 231.83 234.605 233.539Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_485_19387",
    x: 119.725,
    y: 170.176,
    width: 20.4404,
    height: 20.4395,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.745833 0 0 0 0 0.279687 0 0 0 0 0.279687 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_485_19387"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniTransport01);
export default __webpack_public_path__ + "static/media/mini_transport_01.06a3d513247570a798fe521111eb4700.svg";
export { ForwardRef as ReactComponent };